<div mat-dialog-title>
	<div class="flex flex-row justify-between items-center -mt-8">
		<div>{{ data.item.label }}</div>
		<button
			mat-icon-button
			mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>
<div mat-dialog-content>
	@if (data.type === "score") {
		<app-score-viewer [selectedScore]="asScore" />
	} @else if (data.type === "formula") {
		<app-formula-viewer [selectedFormula]="asFormula" />
	}
</div>
